import { render } from "./long-insure.vue?vue&type=template&id=32d61564&scoped=true&ts=true"
import script from "./long-insure.vue?vue&type=script&lang=ts"
export * from "./long-insure.vue?vue&type=script&lang=ts"

import "./long-insure.vue?vue&type=style&index=0&id=32d61564&scoped=true&lang=stylus"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d61564"]])

export default __exports__